export default __webpack_public_path__ + "static/hero_image-3fe3deed50690ecdbdb5082a3db9fe2d.webp";